<template>
    <div class="modal-container">
        <div class="modal-form-container">
            <div class="title-container">
                <h2 style="display:inline-block;" v-text="getProductLanguage(modalData, 'subItemName')"></h2>
            </div>

            <div v-for="(subGroup, groupKey) in modalData.subItemProductGroups" :key="groupKey"
                class="subgroups-container" :id="'combo-combo-group-' + groupKey">

                <div class="subgroup-title" @click="toggleHideGroup(groupKey)">
                    <div style="margin:auto 0">
                        <span class="circle" :class="{ 'disabledCircle': disabledTitle[groupKey] }"
                            v-text="(groupKey + 1)"></span>
                        <h2 style="display:inline-block;" :class="{ 'disabledTitle': disabledTitle[groupKey] }"
                            v-text="getProductLanguage(subGroup, 'subProductGroupName')"></h2>
                    </div>
                    <div class="count" :class="{ 'disabledTitle': disabledTitle[groupKey] }"
                        v-text="buildText(groupKey)"></div>
                </div>
                <div class="comb-prod-item-container"
                    :class="{ 'displaylist': (allowMultipleAdd && subGroup.subProductGroupMax > 1) || itemsList, 'hideGroup': hideGroup[groupKey] }">
                    <div class="item-comb-prod"
                        v-for="(prod, prodKey) in removeBlockedProds(subGroup.subProductGroupItems)" :key="prodKey"
                        :class="{ 'selected': isSelected(subGroup, prod) }">
                        <template v-if="allowMultipleAdd && subGroup.subProductGroupMax > 1">
                            <div v-if="!itemsList" class="image-label-left">
                                <img v-if="prod.subItemProductImages && prod.subItemProductImages.large != null"
                                    :src="getImagesURL(prod, 'subItemProductImages', 'large')" alt="">
                                <img v-else-if="useAlternativeLayout" :src="noImageSrc">
                            </div>

                            <QuantityControl :quantity="prod.quantity || 0"
                                @circleBtnRemove="decreaseQtty(prod, subGroup, groupKey)"
                                @circleBtnAdd="increaseQtty(prod, subGroup, groupKey, prodKey)">
                            </QuantityControl>

                            <label class="image-label-container" :for="groupKey + prodKey + prod.subItemCode" :class="{
                                'disabled-click': prod.subItemMandatory === 'S' && prod.subItemPreSelected === 'S',
                                'expand-width': itemsList,
                                'align-center': !itemsList
                            }">

                                <span class="name" v-text="getProductLanguage(prod, 'subItemName')"></span>
                                <span class="price full-min-price" v-if="getFullMinPrice(prod, subGroup)" v-text="formatMoney(getFullMinPrice(prod, subGroup))"></span>
                                <span class="price"
                                    v-if="showChildsPrice(prod, modalData.firstLevelFatherPrint, subGroup.subProductGroupPrint) && prod.price"
                                    v-text="getProdPrice(prod, subGroup)">
                                </span>
                            </label>
                        </template>

                        <template v-else>
                            <div class="container-input">
                                <input class="styled-input" :id="groupKey + prodKey + prod.subItemCode" type="checkbox"
                                    :class="{ 'disabled-click': prod.subItemMandatory === 'S' && prod.subItemPreSelected === 'S' }"
                                    :value="prod" @change="onSubProdChoose(prod, subGroup, groupKey, $event, prodKey)"
                                    v-model="modalData.choosen[subGroup.subProductGroupCode]">

                                <label class="checkmark radio" :for="groupKey + prodKey + prod.subItemCode"
                                    :class="{ 'disabled-click': prod.subItemMandatory === 'S' && prod.subItemPreSelected === 'S' }">
                                </label>
                            </div>

                            <label class="image-label-container" :for="groupKey + prodKey + prod.subItemCode" :class="{
                                'disabled-click': prod.subItemMandatory === 'S' && prod.subItemPreSelected === 'S',
                                'expand-width': itemsList
                            }">

                                <template v-if="!itemsList">
                                    <img v-if="prod.subItemProductImages && prod.subItemProductImages.large != null"
                                        :src="getImagesURL(prod, 'subItemProductImages', 'large')" alt="">
                                    <img v-else-if="useAlternativeLayout" :src="noImageSrc">
                                </template>

                                <span class="name" v-text="getProductLanguage(prod, 'subItemName')"></span>
                                <span class="price full-min-price" v-if="showChildsPrice(prod, modalData.firstLevelFatherPrint, subGroup.subProductGroupPrint) && prod.price && getFullMinPrice(prod, subGroup)" v-text="formatMoney(getFullMinPrice(prod, subGroup))"></span>
                                <span class="price"
                                    v-if="showChildsPrice(prod, modalData.firstLevelFatherPrint, subGroup.subProductGroupPrint) && prod.price"
                                    v-text="getProdPrice(prod, subGroup)">
                                </span>
                            </label>
                        </template>
                    </div>
                </div>
            </div>
        </div>

        <div class="prod-item-footer">
            <DefaultButton v-if="modalData.subItemMandatory !== 'S' || modalData.subItemPreSelected !== 'S'"
                :text="getString('cancelar')" outlined="true" @defaultBtnClick="modalCancel()"></DefaultButton>
            <DefaultButton :text="getString('confirmar')" @defaultBtnClick="modalConfirm()"></DefaultButton>
        </div>

        <div class="overlay" v-if="showObservationsModal"></div>
        <ObservationsModal v-if="showObservationsModal" :obsModalProd="obsModalProd" @obsModalClose="obsModalClose">
        </ObservationsModal>
    </div>
</template>

<script>
/* eslint-disable */
import Util from '@/assets/libs/util'
import QuantityControl from '@/components/QuantityControl'
import DefaultButton from '@/components/DefaultButton'
import ObservationsModal from '@/components/ObservationsModal'
import LocaleController from '@/assets/controllers/LocaleController'
import CartController from '../assets/controllers/CartController'
import DifferentiatedPricesController from '@/assets/controllers/DifferentiatedPricesController'
export default {
    name: 'ModalComboDoCombo',
    components: {
        QuantityControl,
        DefaultButton,
        ObservationsModal
    },
    data() {
        return {
            allowMultipleAdd: Util.getLocalConfigs('allowMultipleAdd'),
            modalDataBkp: null,
            obsModalProd: null,
            obsModalSubGroupCode: null,
            showObservationsModal: false,
            itemsList: Util.getLocalConfigs('itemsList'),
            useAlternativeLayout: Util.getLocalConfigs('useAlternativeLayout'),
            hideGroup: {},
            disabledTitle: {},
            mutexData: {},
            noImageSrc: null,
            junk: require('../../static/icons/junk-icon.png'),
            signalsDiscount: Util.getLocalConfigs('signalsDiscount')
        }
    },
    props: ['modalData', 'depth'],
    watch: {
        mutexData: function () {
            this.modalData.subItemProductGroups.forEach((subGroup, index) => {
                let mutexCode = this.modalData.subItemProductGroups[index].subProductGroupMutex
                let isMutexGroup = mutexCode && this.mutexData[mutexCode]
                let hasAnyMutexSelected = this.mutexData[mutexCode] && this.mutexData[mutexCode].selectedMutexCode != null
                let isNotSelectedMutex = this.mutexData[mutexCode]
                    && this.mutexData[mutexCode].selectedMutexCode !== this.modalData.subItemProductGroups[index].subProductGroupCode

                if (isMutexGroup && hasAnyMutexSelected && isNotSelectedMutex) {
                    this.hideGroup[index] = true
                    this.disabledTitle[index] = true
                } else {
                    this.disabledTitle[index] = false
                }
            })
        }
    },
    created () {
        this.buildHideGroupObject()
        this.buildDisabledTitleObject()

        if (!this.modalData.choosen) {
            this.modalData.choosen = {}
            this.modalData.subItemProductGroups.forEach(subItem => {
                this.modalData.choosen[subItem.subProductGroupCode] = []
            })
        } else {
            // Restaura o preço original dos produtos de this.choosen, para garantir o funcionamento do v-model dos
            // checkboxes. Os produtos com QuantityControl não são afetados pela função
            this.restoreOriginalPrices()
        }

        this.modalDataBkp = Util.deepCopy(this.modalData)
    },
    mounted () {
        this.noImageSrc = Util.getConfigImage('noImage') ? Util.getConfigImage('noImage') : this.junk

        this.mutexData = this.modalData.mutexData ? this.modalData.mutexData : this.buildMutexData()
        let isEditing = this.modalData.edit
        if (!isEditing) {
            this.fillPreselectedProducts(this.modalData.subItemProductGroups)
        }
        this.evaluateHideGroups()
        this.$forceUpdate()
    },
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        },
        getImagesURL: function (prod, prop, size) {
            return Util.getImagesUrl(prod, prop, size)
            // return Util.getLocalConfigs('urlIMGOdhenInterface')
        },
        getProdPrice: function (prod, subGroup) {
            let showMinPriceDifference = Util.getLocalConfigs('showMinPriceDifference')
            let groupHasMinPrice = subGroup && subGroup.minPrice != null
            let groupMin = subGroup && subGroup.subProductGroupMin > 0
            let diffPrice = DifferentiatedPricesController.getDiffPrice(prod.subItemCode || prod.productCode, true, prod)
            let price = 0

            if (showMinPriceDifference && groupHasMinPrice && groupMin) {
                price = (diffPrice || prod.price) - subGroup.minPrice
            } else {
                price = (diffPrice || prod.price)
            }
            return price > 0 ? ` + ${Util.formatMoney(price)}` : ''
        },
        getFullMinPrice: function (prod, subGroup) {
            let showMinPriceDifference = Util.getLocalConfigs('showMinPriceDifference')
            let groupHasMinPrice = subGroup && subGroup.minPrice != null
            let groupMin = subGroup && subGroup.subProductGroupMin > 0
            let fullMinPrice = 0
            let diffPrice = DifferentiatedPricesController.getDiffPrice(prod.subItemCode || prod.productCode, true, prod)
            if (!this.signalsDiscount) {
                return null
            }
            let fullPrice = prod.fullPrice
            let price = prod.price
            if (!fullPrice || fullPrice === 0 || price == 0 || !price || (price + 1) >= fullPrice) {
                return null
            }
            if (showMinPriceDifference && groupHasMinPrice && groupMin) {
                fullMinPrice = (diffPrice || prod.fullPrice) - subGroup.minPrice
            } else {
                fullMinPrice = (diffPrice || prod.fullPrice)
            }
            return fullMinPrice
        },
        removeBlockedProds: function (prods) {
            return Util.removeBlockedProds(prods)
        },
        evaluateHideGroups: function () {
            this.modalData.subItemProductGroups.forEach((subGroup, index) => {
                let isSingleProdPreselec = (subGroup.subProductGroupItems && subGroup.subProductGroupItems.length === 1)
                    && subGroup.subProductGroupItems[0].subItemPreSelected === 'S'
                let isOptionalGroup = false // subGroup.subProductGroupMin === 0
                let mutexCode = this.modalData.subItemProductGroups[index].subProductGroupMutex
                let isMutexGroup = mutexCode && this.mutexData[mutexCode]
                let isFirstMutexGroup = isMutexGroup
                    && this.mutexData[mutexCode].groups[0].subProductGroupCode === this.modalData.subItemProductGroups[index].subProductGroupCode
                let hasAnyMutexSelected = this.mutexData[mutexCode] && this.mutexData[mutexCode].selectedMutexCode != null
                let isSelectedMutex = this.mutexData[mutexCode]
                    && this.modalData.subItemProductGroups[index].subProductGroupCode === this.mutexData[mutexCode].selectedMutexCode

                if (isSingleProdPreselec || isOptionalGroup || isMutexGroup) {
                    this.hideGroup[index] = true
                    if (isMutexGroup && hasAnyMutexSelected && !isSelectedMutex) {
                        this.disabledTitle[index] = true
                    }
                }

                if ((isFirstMutexGroup && !hasAnyMutexSelected) || (isMutexGroup && hasAnyMutexSelected && isSelectedMutex)) {
                    this.hideGroup[index] = false
                }
            })
        },
        checkHideGroup: function (groupKey) {
            let hideGroupOnMax = Util.getLocalConfigs('hideGroupOnMax')
            if (hideGroupOnMax && !this.hideGroup[groupKey]) {
                this.toggleHideGroup(groupKey)
            }
        },
        toggleHideGroup: function (groupKey) {
            let mutexCode = this.modalData.subItemProductGroups[groupKey].subProductGroupMutex
            let isMutexGroup = mutexCode && this.mutexData[mutexCode]
            let hasAnyMutexSelected = this.mutexData[mutexCode] && this.mutexData[mutexCode].selectedMutexCode != null
            let isSelectedMutex = this.mutexData[mutexCode]
                && this.modalData.subItemProductGroups[groupKey].subProductGroupCode === this.mutexData[mutexCode].selectedMutexCode

            if (!isMutexGroup || !hasAnyMutexSelected || isSelectedMutex) {
                this.hideGroup[groupKey] = !this.hideGroup[groupKey]
                this.$forceUpdate()
            }
        },
        buildHideGroupObject: function () {
            this.modalData.subItemProductGroups.forEach((subGroup, index) => {
                this.hideGroup[index] = false
            })
        },
        buildDisabledTitleObject: function () {
            this.modalData.subItemProductGroups.forEach((subGroup, index) => {
                this.disabledTitle[index] = false
            })
        },
        fillPreselectedProducts: function (productGroups) {
            productGroups.forEach((group, groupKey) => {
                if (group.subProductGroupItems && group.subProductGroupItems.length > 0) {
                    let filteredSubProductGroupItems = Util.removeBlockedProds(group.subProductGroupItems)

                    filteredSubProductGroupItems.forEach((product, productKey) => {
                        if (product.subItemPreSelected === 'S') {
                            this.onSubProdChoose(product, group, groupKey, 'preselected', productKey)
                            this.$forceUpdate()
                        }
                    })
                }
            })
        },
        obsModalClose: function (obsModalProd) {
            CartController.setProductSequence(obsModalProd, false, this.depth + 1, (obsModalProd.groupKey + 1), (obsModalProd.prodIndex + 1))
            this.modalData.choosen[this.obsModalSubGroupCode].push(obsModalProd)
            this.updateSelectedMutex()

            let currentGroup = this.modalData.subItemProductGroups.find(group => group.subProductGroupCode === this.obsModalSubGroupCode)
            let groupMaxItems = currentGroup.subProductGroupMax
            let groupSelectedItems = 0
            let selectedItemsFromGroup = this.modalData.choosen[this.obsModalSubGroupCode] || []
            selectedItemsFromGroup.forEach(prod => {
                groupSelectedItems += prod.quantity || 1
            })

            if (groupSelectedItems === groupMaxItems) {
                let groupKey = this.modalData.subItemProductGroups.findIndex(group => group.subProductGroupCode === this.obsModalSubGroupCode)
                this.checkHideGroup(groupKey)
                this.jumpGroup(groupKey)
            }

            this.showObservationsModal = false
            this.obsModalSubGroupCode = null
        },
        jumpGroup: function (groupKey) {
            try {
                let mutexCode = this.modalData.subItemProductGroups[groupKey].subProductGroupMutex
                let isMutexGroup = mutexCode && this.mutexData[mutexCode]

                if (isMutexGroup) {
                    let nextGroups = (this.modalData.subItemProductGroups || []).slice(groupKey + 1)
                    let nextNotMutexIndex = nextGroups.findIndex(element => element.subProductGroupMutex !== mutexCode)
                    if (nextNotMutexIndex !== -1) {
                        let groupsToJump = groupKey + 1 + nextNotMutexIndex
                        location.hash = '#combo-combo-group-' + groupsToJump
                    }
                } else {
                    let nextGroupHash = groupKey + 1
                    location.hash = '#combo-combo-group-' + nextGroupHash
                }
            } catch (error) {
                console.log(error.message)
                Util.logComunication('Exception ', {}, error.message)
            }
        },
        restoreOriginalPrices: function () {
            let currentChoosen = this.modalData.choosen
            let originalProds = this.modalData.subItemProductGroups
            let keys = Object.keys(currentChoosen)
            keys.forEach(key => {
                currentChoosen[key].forEach(choosenProd => {
                    if (choosenProd.groupKey != null) {
                        let originalProduct = originalProds[choosenProd.groupKey].subProductGroupItems
                            .find(current => current.subItemCode === choosenProd.subItemCode)
                        choosenProd.price = originalProduct.price
                    }
                })
            })
        },
        decreaseQtty: function (prod, subGroup, groupKey) {
            let thisProdIndex
            if (!this.modalData.edit) {
                thisProdIndex = this.modalData.choosen[subGroup.subProductGroupCode].findIndex(element => element === prod)
            } else {
                thisProdIndex = this.modalData.choosen[subGroup.subProductGroupCode].findIndex(element => element.subItemCode === prod.subItemCode)
            }

            let isMandatory = prod.subItemMandatory === 'S'
            let minProductQuantity = isMandatory ? 1 : 0

            if (prod.quantity && prod.quantity > minProductQuantity) {
                prod.quantity--
            } else if (isMandatory) {
                Util.showErrorNotification({ title: this.getString('produto_obrigatorio') + ' ' + prod.subItemName, text: null })
            }
            this.$forceUpdate()

            if (thisProdIndex !== -1) {
                this.modalData.choosen[subGroup.subProductGroupCode][thisProdIndex].quantity = prod.quantity
                if (this.modalData.choosen[subGroup.subProductGroupCode][thisProdIndex].quantity === 0) {
                    this.modalData.choosen[subGroup.subProductGroupCode].splice(thisProdIndex, 1)
                    this.updateSelectedMutex()
                }
            }
        },
        increaseQtty: function (prod, subGroup, groupKey, prodKey) {
            let thisProdIndex
            let hasObservations = this.hasObservations(prod) // (prod.subItemObservationsChoice || []).length > 0
            let typedObsEnabled = Util.getLocalConfigs('permiteObsDigitada')

            if (!this.modalData.edit) {
                thisProdIndex = this.modalData.choosen[subGroup.subProductGroupCode].findIndex(element => element === prod)
            } else {
                thisProdIndex = this.modalData.choosen[subGroup.subProductGroupCode].findIndex(element => element.subItemCode === prod.subItemCode)
            }

            if (!prod.quantity) {
                prod.quantity = 0
            }

            let maxItens = subGroup.subProductGroupMax
            let totalGroupItens = 0
            this.modalData.choosen[subGroup.subProductGroupCode].forEach(option => {
                totalGroupItens += option.quantity
            })

            if (totalGroupItens < maxItens) {
                prod.quantity++

                if (totalGroupItens + 1 === maxItens) {
                    this.checkHideGroup(groupKey)
                    this.jumpGroup(groupKey)
                }

                this.$forceUpdate()

                if (thisProdIndex === -1) {
                    if (hasObservations || typedObsEnabled) {
                        this.obsModalProd = prod
                        this.obsModalProd.prodIndex = prodKey
                        this.obsModalProd.groupKey = groupKey
                        this.obsModalSubGroupCode = subGroup.subProductGroupCode
                        this.showObservationsModal = true
                    } else {
                        this.modalData.choosen[subGroup.subProductGroupCode].push(prod)
                        CartController.setProductSequence(prod, false, this.depth + 1, (groupKey + 1), (prodKey + 1))
                        this.updateSelectedMutex()
                    }
                } else {
                    this.modalData.choosen[subGroup.subProductGroupCode][thisProdIndex].quantity = prod.quantity
                }
            } else {
                Util.showErrorNotification({ title: this.getString('atingiu_limite_categoria'), text: null })
            }
        },
        onSubProdChoose: function (prod, subGroup, groupKey, event, prodKey) {
            prod.groupKey = groupKey
            let hasObservations = this.hasObservations(prod) // (prod.subItemObservationsChoice || []).length > 0
            let typedObsEnabled = Util.getLocalConfigs('permiteObsDigitada')

            if (hasObservations || typedObsEnabled) {
                if (subGroup.subProductGroupMax === 1) {
                    this.modalData.choosen[subGroup.subProductGroupCode] = []
                    this.updateSelectedMutex()
                    if ((event && event === 'preselected') || prod.subItemMandatory === 'S' || (event && event.srcElement.checked)) {
                        this.obsModalProd = prod
                        this.obsModalProd.prodIndex = prodKey
                        this.obsModalProd.groupKey = groupKey
                        this.obsModalSubGroupCode = subGroup.subProductGroupCode
                        this.showObservationsModal = true
                    }
                } else if (this.modalData.choosen[subGroup.subProductGroupCode].length > subGroup.subProductGroupMax) {
                    this.modalData.choosen[subGroup.subProductGroupCode].pop()
                    event.srcElement.checked = false
                    this.updateSelectedMutex()
                }
            } else {
                if (subGroup.subProductGroupMax === 1) {
                    this.modalData.choosen[subGroup.subProductGroupCode] = []
                    this.updateSelectedMutex()
                    if ((event && event === 'preselected') || prod.subItemMandatory === 'S' || (event && event.srcElement.checked)) {
                        CartController.setProductSequence(prod, false, this.depth + 1, (groupKey + 1), (prodKey + 1))
                        this.modalData.choosen[subGroup.subProductGroupCode].push(prod)
                        this.updateSelectedMutex()
                    }
                } else if (subGroup.subProductGroupMax > 1 && this.modalData.choosen[subGroup.subProductGroupCode].length < subGroup.subProductGroupMax) {
                    if ((event && event === 'preselected') || prod.subItemMandatory === 'S' || (event && event.srcElement.checked)) {
                        prod.quantity = 1
                        this.modalData.choosen[subGroup.subProductGroupCode].push(prod)
                        this.updateSelectedMutex()
                    }
                } else if (this.modalData.choosen[subGroup.subProductGroupCode].length > subGroup.subProductGroupMax) {
                    this.modalData.choosen[subGroup.subProductGroupCode].pop()
                    event.srcElement.checked = false
                    this.updateSelectedMutex()
                }
            }

            let groupMaxItems = subGroup.subProductGroupMax
            let groupSelectedItems = 0
            let selectedItemsFromGroup = this.modalData.choosen[subGroup.subProductGroupCode] || []
            selectedItemsFromGroup.forEach(prod => {
                groupSelectedItems += prod.quantity || 1
            })
            if (groupSelectedItems === groupMaxItems) {
                this.checkHideGroup(groupKey)
                this.jumpGroup(groupKey)
            }

            this.$forceUpdate()
        },
        showChildsPrice: function (prod, firstLevelFatherPrint, childGroupPrint) {
            // Essa flag será necessária em outras rotinas. Inseri-la em cada subproduto aqui evitará repetir esse processamento
            prod.groupPrint = childGroupPrint
            prod.firstLevelFatherPrint = firstLevelFatherPrint

            if (firstLevelFatherPrint === 'S' && childGroupPrint === 'S') {
                // Se o produto principal do primeiro nível é imprime sim e o grupo promocional do terceiro nivel também é imprime sim, deve exibir o preço dos filhos
                return true
            } else if (firstLevelFatherPrint === 'N') {
                // Se o produto principal do primeiro nível é imprime não, sempre deve exibir o preço dos itens filhos
                return true
            } else {
                return false
            }
        },
        formatMoney: function (price) {
            return Util.formatMoney(price)
        },
        buildText: function (index) {
            let text1 = this.getString('escolha')
            let text2 = ''

            if (this.modalData.subItemProductGroups[index].subProductGroupMin === this.modalData.subItemProductGroups[index].subProductGroupMax) {
                text2 = this.modalData.subItemProductGroups[index].subProductGroupMax
            } else {
                text2 = this.getString('ate') + ` ${this.modalData.subItemProductGroups[index].subProductGroupMax}`
            }

            let text3 = this.modalData.subItemProductGroups[index].subProductGroupMax === 1 ? this.getString('opcao') : this.getString('opcoes')
            return text1 + text2 + text3
        },
        modalCancel: function () {
            let clickedElementId = this.modalData.clickedElementId
            this.modalData.choosen = this.modalDataBkp.choosen
            this.modalData.subItemProductGroups = this.modalDataBkp.subItemProductGroups
            this.updateSelectedMutex()
            this.$emit('modalCancel', clickedElementId)
        },
        modalConfirm: function () {
            if (this.validateChooses()) {
                let option = Util.deepCopy(this.modalData)
                option.mutexData = this.mutexData
                // Evita multiplicar quantidades quando o mesmo produto for escolhido multiplas vezes
                if (option.quantity && option.quantity > 1) option.quantity = 1
                delete this.modalData.choosen
                this.modalData.subItemProductGroups = this.modalDataBkp.subItemProductGroups
                this.$emit('modalConfirm', option)
            }
        },
        validateChooses: function () {
            let validChooses = true
            let choosen = this.modalData.choosen
            let comboOptions = this.modalData.subItemProductGroups
            let self = this

            comboOptions.reverse().forEach(function (group, index) {
                let mutexCode = self.modalData.subItemProductGroups[index].subProductGroupMutex
                let isMutexGroup = mutexCode && self.mutexData[mutexCode]
                let hasAnyMutexSelected = self.mutexData[mutexCode] && self.mutexData[mutexCode].selectedMutexCode != null
                let isSelectedMutex = isMutexGroup && self.modalData.subItemProductGroups[index].subProductGroupCode === self.mutexData[mutexCode].selectedMutexCode

                if (group.subProductGroupMin > 0 && !choosen[group.subProductGroupCode] && (!isMutexGroup || !hasAnyMutexSelected || isSelectedMutex)) {
                    validChooses = false
                    Util.showErrorNotification({ title: self.getString('voce_precisa_selecionar_algum') + group.subProductGroupName, text: null })
                } else if (choosen[group.subProductGroupCode] && (!isMutexGroup || !hasAnyMutexSelected || isSelectedMutex)) {
                    let totalGroupSelected = 0
                    choosen[group.subProductGroupCode].forEach(product => {
                        totalGroupSelected += product.quantity ? product.quantity : 1
                    })
                    if (totalGroupSelected < group.subProductGroupMin) {
                        validChooses = false
                        Util.showErrorNotification({ title: self.getString('voce_precisa_selecionar_algum') + group.subProductGroupName, text: null })
                    }
                }
            })

            comboOptions.reverse()
            return validChooses
        },
        buildMutexData: function () {
            let mutexData = {}

            this.modalData.subItemProductGroups.forEach((group, index) => {
                if (group.subProductGroupMutex && group.subProductGroupMutex !== null) {
                    if (!mutexData[group.subProductGroupMutex]) {
                        mutexData[group.subProductGroupMutex] = {
                            groups: [],
                            selectedMutexCode: null
                        }
                    }
                    mutexData[group.subProductGroupMutex].groups.push({
                        productGroupName: group.subProductGroupName,
                        productGroupCode: group.subProductGroupCode,
                        productGroupIndex: index
                    })
                }
            })

            let mutexKeys = Object.keys(mutexData)
            mutexKeys.forEach(key => {
                // Se o grupo mutex contiver apenas um grupo de produtos, ele não precisa ser tratado como mutex
                if (mutexData[key].groups.length < 2) {
                    delete mutexData[key]
                }
            })

            return mutexData
        },
        updateSelectedMutex: function () {
            let choosenExists = this.modalData.choosen != null && this.modalData.choosen !== {}
            let mutexDataExists = this.mutexData != null && this.mutexData !== {}

            if (choosenExists && mutexDataExists) {
                let newMutexData = Util.deepCopy(this.mutexData)
                let keys = Object.keys(newMutexData)

                keys.forEach(key => {
                    let currentMutex = newMutexData[key]
                    currentMutex.selectedMutexCode = null

                    currentMutex.groups.forEach(group => {
                        let thisGroupHasProductSelected = this.modalData.choosen && this.modalData.choosen[group.productGroupCode]
                            && this.modalData.choosen[group.productGroupCode].length > 0

                        if (thisGroupHasProductSelected) {
                            currentMutex.selectedMutexCode = group.productGroupCode
                        }
                    })
                })

                this.mutexData = newMutexData
            }
        },
        getProductLanguage: function (product, index) {
            return LocaleController.getIndexLanguages(product, index)
        },
        isSelected: function (subGroup, prod) {
            if (this.modalData.choosen && this.modalData.choosen[subGroup.subProductGroupCode]) {
                let selected = this.modalData.choosen[subGroup.subProductGroupCode].find(e => e.subItemCode === prod.subItemCode)
                if (selected && selected !== -1) {
                    return true
                }
            }
            return false
        },
        hasObservations: function (prod) {
            if (!Array.isArray(prod.subItemObservationsChoice) || prod.subItemObservationsChoice.length === 0) {
                return false
            }
            return prod.subItemObservationsChoice.some(obs => {
                let filteredObservations = Util.removeBlockedProdsObs(obs.subItemObservations)
                if (filteredObservations.length > 0) {
                    return true
                }
            })
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
@import (reference) url("../assets/common.less");

.modal-container {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: 75px;
    background: @white;
    border-radius: 25px;
    z-index: 2;
    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
    padding-bottom: 80px;

    .hideGroup {
        display: none !important;
    }

    .modal-form-container {
        position: relative;
        height: calc(100% - 100px);
        overflow: hidden auto;
    }

    .title-container {
        margin: 25px 0;
        padding-top: 20px;
        padding-bottom: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;

        h2 {
            color: @primary-color;
            padding: 0;
            padding-left: 15px;
            font-size: calc(1vw + 2vh);
        }
    }

    .subgroups-container {
        // box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
        margin: 15px;
        padding-bottom: 15px;

        .subgroup-title {
            margin: 25px 0;
            padding-top: 20px;
            padding-bottom: 20px;
            display: grid;
            grid-template-columns: 77% 23%;

            h2 {
                color: @primary-color;
                vertical-align: middle;
                text-align: left;
                width: calc(100% - 140px);
                padding: 0;
                padding-left: 15px;
                font-size: calc(1vw + 2vh);
            }

            .count {
                color: @primary-color;
                font-size: 1.3em;
                margin: auto;
            }

            .circle {
                margin-left: 30px;
                display: inline-block;
                width: 60px;
                height: 60px;
                border-radius: 50%;
                background-color: @primary-color;
                color: white;
                text-align: center;
                align-items: bottom;
                height: 50px;
                line-height: 50px;
                padding: 15px 12px 15px 12px;
            }
        }

        .item-comb-prod {
            display: flex;
            margin-top: 15px;
            align-items: center;

            width: 40%;
            box-shadow: 2px 3px 5px 3px rgba(0, 0, 0, 0.1);

            .container-input {
                display: none;
            }

            .image-label-container {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                width: 100%;

                img {
                    display: block;
                    margin: auto;
                    height: auto;
                    min-height: 150px;
                    max-height: 200px;
                    object-fit: contain;
                    width: 100%;
                }

                .name {
                    text-align: center;
                    padding: 10px 15px;
                }

                .price {
                    text-align: center;
                    padding: 10px 15px;
                }
            }

            .align-center {
                align-items: center;
            }

            .expand-width {
                width: 100% !important;
            }

            .image-label-left {
                padding-left: 15px;
                display: flex;
                flex-direction: column;

                img {
                    height: 150px;
                    width: 150px;
                    margin-right: 30px;
                }
            }

            &.selected {
                box-shadow: 1px 1px 3px 4px rgba(19, 165, 0, 0.2);
                background-color: rgba(19, 165, 0, 0.05);
            }
        }
    }

    .prod-item-footer {
        display: flex;
        background: rgba(0, 0, 0, 0.1);
        height: 180px;
        border-radius: 0px 0px 25px 25px;

        button {
            position: relative;
            display: block;
            margin: auto;
        }
    }
}

.comb-prod-item-container {
    display: flex;
    margin-bottom: 20px;
    // grid-template-columns: 50% 50%;
    flex-wrap: wrap;
    justify-content: space-around;
    /* &.displaylist{
                display: block;
                .item-comb-prod {
                    padding-bottom: 20px;
                }
            } */

    &.displaylist {
        .item-comb-prod {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            width: 100%;
            margin: 0px 30px 30px 30px;
            padding: 30px 15px;

            div {
                padding-right: 15px;
            }

            .image-label-container {
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                flex-direction: row;
            }
        }
    }

    .price {
        font-family: @default-font;
        font-size: 2rem;
        color: var(--price-font-color);
        margin: 0;
    }
    .price.full-min-price {
        text-decoration: line-through;
        color: @disabled-color;
        font-size: 1.6rem !important;
        padding: 0 !important;
    }
}

.disabled-click {
    pointer-events: none
}

.disabledTitle {
    color: @disabled-color !important;
}

.disabledCircle {
    background-color: @disabled-color !important;
}

.overlay {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.8);
    z-index: 1;
}

@media (max-width: 698px) {

    // Gertec SK210
    .modal-container {
        margin: 25px;
        padding-bottom: 0;
        border-radius: 10px;

        .modal-form-container {
            height: calc(100% - 60px);
            &::-webkit-scrollbar {
                margin-top: 20px; /* Reduz a altura/espessura da barra horizontal */
            }
        }

        .title-container {
            margin: 0;
        }

        .subgroups-container {
            .subgroup-title {
                padding-top: 0;
                padding-bottom: 0;
                grid-template-columns: 75% 25%;

                .count {
                    font-size: 16px;
                }

                .circle {
                    margin-left: 0;
                    width: 30px;
                    height: 30px;
                    line-height: 30px;
                    padding: 3px 3px 3px 3px;
                }

                h2 {
                    padding-left: 10px;
                }
            }

            .comb-prod-item-container {
                .item-comb-prod {
                    margin: 5px 0px;
                    box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.1);

                    .image-label-container {
                        img {
                            display: block;
                            margin: auto;
                            height: auto;
                            min-height: 80px;
                            max-height: 110px;
                        }

                        .name {
                            text-align: center;
                            padding: 5px 5px;
                            font-size: 15px;
                        }

                        .price {
                            text-align: center;
                            padding: 5px 5px;
                            font-size: 15px;
                        }
                        .price.full-min-price {
                            font-size: 13px !important;
                        }
                    }

                    .align-center {
                        align-items: center;
                    }

                    .expand-width {
                        width: 100% !important;
                    }
                }
                
                &.displaylist {
                    .item-comb-prod {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        justify-content: center;
                        width: 100%;
                        margin: 0px 5px 10px 5px;
                        padding: 10px 10px;

                        div {
                            padding-right: 15px;
                        }

                        .image-label-container {
                            width: 100%;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            flex-direction: row;
                        }
                    }
                }
            }
        }

        .prod-item-footer {
            height: 60px;
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 10px;
            button {
                box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);
                width: 45%;
            }
        }

        .price {
            font-size: 15px;
        }
        .price.full-min-price {
            font-size: 12px !important;
        }
    }
    .modal-container .modal-form-container::-webkit-scrollbar-track {
        background: #c5c5c5fe;
        border-top-right-radius: 10px;
        margin-top: 5px;
    }
}

@media (min-width: 699px) and (max-width: 1025px) {
    //@tablet

    .modal-container {
        margin: 50px;

        .modal-form-container {
            height: calc(100% - 50px);
        }

        .subgroups-container {
            .subgroup-title {
                .count {
                    font-size: 30px;
                }

                .circle {
                    margin-left: 20px;
                    width: 40px;
                    height: 40px;
                    line-height: 40px;
                    padding: 12px;
                    font-size: 30px;
                }
            }

            .comb-prod-item-container {
                .item-comb-prod {
                    display: flex;
                    margin-top: 15px;
                    align-items: center;

                    box-shadow: 2px 3px 5px 3px rgba(0, 0, 0, 0.1);

                    .image-label-container {
                        img {
                            display: block;
                            margin: auto;
                            height: auto;
                            min-height: 130px;
                            max-height: 160px;
                            object-fit: contain;
                            width: 100%;
                        }

                        .name {
                            text-align: center;
                            padding: 10px 10px;
                        }

                        .price {
                            text-align: center;
                            padding: 10px 10px;
                            font-size: 20px;
                        }
                        .price.full-min-price {
                            font-size: 16px !important;
                        }
                    }

                    .align-center {
                        align-items: center;
                    }

                    .expand-width {
                        width: 100% !important;
                    }
                }
                
                &.displaylist {
                        .item-comb-prod {
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            justify-content: center;
                            width: 100%;
                            margin: 0px 15px 15px 15px;
                            padding: 15px 15px;

                            div {
                                padding-right: 15px;
                            }

                            .image-label-container {
                                width: 100%;
                                display: flex;
                                justify-content: space-between;
                                align-items: center;
                                flex-direction: row;
                            }
                        }
                    }
            }
        }

        .prod-item-footer {
            height: 130px;
        }
    }

    .comb-prod-item-container {
        .price {
            font-size: 1.5rem;
        }
        .price.full-min-price {
            font-size: 1.3rem !important;
        }
    }
}

@media (orientation: landscape) {
    .modal-container {
        margin: 30px 50px;

        .modal-form-container {
            height: 100%;
        }

        .subgroups-container {
            .subgroup-title {
                h2 {
                    vertical-align: unset;
                }

                .count {
                    font-size: 25px;
                }

                .circle {
                    margin-left: 20px;
                    width: 35px;
                    height: 35px;
                    line-height: 35px;
                    padding: 12px;
                    font-size: 30px;
                }
            }

            .comb-prod-item-container {
                .item-comb-prod {
                    display: flex;
                    margin-top: 15px;
                    align-items: center;
                    width: 27%;
                    box-shadow: 2px 3px 5px 3px rgba(0, 0, 0, 0.1);

                    .image-label-container {
                        img {
                            display: block;
                            margin: auto;
                            height: auto;
                            min-height: 130px;
                            max-height: 160px;
                            object-fit: contain;
                            width: 100%;
                        }

                        .name {
                            text-align: center;
                            padding: 10px 10px;
                        }

                        .price {
                            text-align: center;
                            padding: 10px 10px;
                            font-size: 20px;
                        }
                        .price.full-min-price {
                            font-size: 16px !important;
                        }
                    }

                    .align-center {
                        align-items: center;
                    }

                    .expand-width {
                        width: 100% !important;
                    }
                }
            }
        }

        .prod-item-footer {
            button {
                width: 40%;
            }

            height: 80px;
        }
    }

    .comb-prod-item-container {
        .price {
            font-size: 1.5rem;
        }
        .price.full-min-price {
            font-size: 1.3rem !important;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ModalComboDoCombo.vue